// Cena 7 — Respostas Rápidas (áudio ~19s)
// O cursor clica no botão real de adicionar, o atalho "/saudacao" aparece
// cadastrado e, na conversa fictícia, digitar "/" abre a sugestão: um
// clique e a mensagem inteira surge prontinha no campo.
const MAIN = "[data-tour='main-content']";
const BTN_ADD = "[data-tour='btn-add-quickanswer']";
const SLASH_INPUT = "[data-demo='slash-input']";
const SLASH_ITEM = "[data-demo='slash-item']";

export default async function quickAnswers(ctx) {
	// "Sabe aquela pergunta que chega todo santo dia?"
	ctx.spotlight(MAIN);
	await ctx.wait(1100);

	// "Você cria um atalho…" — clique no botão REAL de adicionar
	await ctx.waitFor(BTN_ADD);
	await ctx.cursorTo(BTN_ADD, { duration: 900 });
	await ctx.wait(300);
	await ctx.click(BTN_ADD);

	// o atalho já cadastrado aparece na lista
	ctx.mount("quickAnswerRow", MAIN, {
		shortcut: "/saudacao",
		message: "Olá! Bem-vindo à Flytec 👋 Como posso ajudar?",
		style: { position: "absolute", left: 24, top: 120, width: 460 },
	});
	await ctx.wait(400);

	// cursor pousa sobre o atalho enquanto a narração explica
	await ctx.cursorTo({ sel: MAIN, ax: 0.2, ay: 0.28 }, { duration: 850 });
	await ctx.wait(2100);

	// "e na conversa, digita só uma barra…" — campo de mensagem fictício
	const slash = ctx.mount("chatSlash", MAIN, {
		typed: "/",
		popup: false,
		style: { position: "absolute", left: 24, bottom: 130, width: 460 },
	});
	await ctx.waitFor(SLASH_INPUT);
	await ctx.cursorTo(SLASH_INPUT, { duration: 950 });
	await ctx.wait(1100);

	// a sugestão aparece sozinha
	ctx.update(slash, { popup: true });
	await ctx.wait(1400);

	// "…e a mensagem inteira aparece prontinha" — clica na sugestão
	await ctx.waitFor(SLASH_ITEM);
	await ctx.cursorTo(SLASH_ITEM, { duration: 700 });
	await ctx.wait(300);
	await ctx.click(SLASH_ITEM);
	ctx.update(slash, {
		popup: false,
		filled: "Olá! Bem-vindo à Flytec 👋 Como posso ajudar?",
	});
	await ctx.wait(1500);

	// "Uma economia de tempo enorme!"
	const toast = ctx.mount("toast", MAIN, {
		icon: "⚡",
		text: "Mensagem pronta em 1 segundo!",
	});
	await ctx.wait(2700);
	ctx.unmount(toast);
	await ctx.wait(400);

	ctx.spotlight(null);
	await ctx.cursorTo({ sel: MAIN, ax: 0.55, ay: 0.45 }, { duration: 850 });
}
